import { forPhoneOnly } from 'src/config/mediaQueries'
import { createUseStyles } from 'react-jss'
import { MAX_CONTAINER_WIDTH } from 'src/config/styles'
import { typography } from '@dentalux/ui-library-core'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  pageContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: [0, 16, 0],
    [forPhoneOnly]: {
      padding: [0, 16],
    },
  },
  treatmentsContainer: {
    width: MAX_CONTAINER_WIDTH,
    maxWidth: MAX_CONTAINER_WIDTH,
    padding: [0, 20, 8, 24],
    [forPhoneOnly]: {
      padding: 0,
      width: '100%',
    },
  },
  categoryContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: [8, 0],
    borderBottom: `1.5px solid ${theme.palette.primary[600]}`,
  },
  clickableCategoryContainer: {
    cursor: 'pointer',
  },
  categoryContainerCollapsed: {
    marginBottom: '24px',
  },
  toggleCategoryIcon: {
    transition: 'all .4s',
  },
  toggleCategoryCollapsed: {
    transform: 'rotate(180deg)',
  },
  categoryName: {
    ...typography['Lato Emphasized 1'],
    color: theme.palette.primary[800],
  },
  categoryIcon: {
    width: 22,
    height: 22,
    marginRight: 12,
  },
  categoryDivider: {
    width: '100%',
    height: 1,
    background: theme.palette.grey['200'],
    margin: '24px 0',
  },
  categoryTreatmentsContainer: {
    borderRadius: '0px 0px 8px 8px',
    boxShadow: theme.shadows[1],
  },
}))
